import { ButtonToolbar, Button, ButtonGroup } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import './pagesNavigator.scss';

const PagesNavigator = (props) => {
  let selectedIndex = 0;
  let history = useHistory();
  props.pages.forEach((item, index) => {
    if (item.path === history.location.pathname) {
      selectedIndex = index;
    }
  });

  const handlingClick = (event) => {
    let isValid = props.beforeNext();
    if (isValid) {
      let nextIndex =
        event.target.value === 'next' ? selectedIndex + 1 : selectedIndex - 1;

      history.push(props.pages[nextIndex].path, { from: history.location.pathname });
    }
  };

  return (
    <ButtonToolbar className="justify-content-between pages-navigator-ctn">
      <div>
        {selectedIndex > 0 && (
          <Button className="custom-btn" value="prev" onClick={handlingClick}>
            Previous Page
          </Button>
        )}
      </div>
      <div>
        {selectedIndex < props.pages.length - 1 && (
          <Button className="custom-btn" value="next" onClick={handlingClick}>
            Next page
          </Button>
        )}
        {selectedIndex === props.pages.length - 1 && (
          <ButtonGroup>
            <Button className="custom-btn" value="next" onClick={props.saveClick}>
              Save &amp; Send
            </Button>
            <Button
              variant="light"
              className="custom-btn"
              value="next"
              onClick={props.cancelClick}
            >
              Cancel
            </Button>
          </ButtonGroup>
        )}
      </div>
    </ButtonToolbar>
  );
};

export default PagesNavigator;
